import { useEffect, useMemo, useState } from "react";
import {
  groupPermissionAccessAnnouncement,
  groupPermissionAccessCMSCareer,
  groupPermissionAccessCMSNotification,
  groupPermissionAccessCMSOverview,
  groupPermissionAccessCMSSetting,
  groupPermissionAccessContent,
  groupPermissionAccessInbox,
  groupPermissionAccessMedia,
  groupPermissionAccessWorkflow,
} from "../../../context-controller-mod/context-serv/permission-provider/permissionExporter";
import { usePermission } from "../../../context-controller-mod/context-serv/permission-provider/permissionProvider";

const FALLBACK_DELAY = 500;

export const useFallbackRoute = () => {
  const { loading } = usePermission();
  const [delayDone, setDelayDone] = useState(false);

  useEffect(() => {
    if (loading) {
      setDelayDone(false);
      return;
    }

    const timer = globalThis.window.setTimeout(() => {
      setDelayDone(true);
    }, FALLBACK_DELAY);

    return () => globalThis.window.clearTimeout(timer);
  }, [loading]);

  const canAccessOverview = groupPermissionAccessCMSOverview.view();
  const canAccessContent = groupPermissionAccessContent.view();
  const canAccessMedia = groupPermissionAccessMedia.view();
  const canAccessCareer = groupPermissionAccessCMSCareer.view();
  const canAccessInbox = groupPermissionAccessInbox.view();
  const canAccessWorkflow = groupPermissionAccessWorkflow.view();
  const canAccessNotification = groupPermissionAccessCMSNotification.view();
  const canAccessSetting = groupPermissionAccessCMSSetting.view();
  const canAccessAnnouncement = groupPermissionAccessAnnouncement.view();

  const fallback = useMemo(() => {
    if (loading || !delayDone) return null;

    if (canAccessOverview) return "/overview";
    if (canAccessContent) return "/content/company";
    if (canAccessMedia) return "/media";
    if (canAccessCareer) return "/career/hire";
    if (canAccessInbox) return "/inbox";
    if (canAccessWorkflow) return "/workflow/manage";
    if (canAccessNotification) return "/notification";
    if (canAccessSetting) return "/setting/digital-asset";
    if (canAccessAnnouncement) return "/";

    return "/forbidden";
  }, [
    loading,
    delayDone,
    canAccessOverview,
    canAccessContent,
    canAccessMedia,
    canAccessCareer,
    canAccessInbox,
    canAccessWorkflow,
    canAccessNotification,
    canAccessSetting,
    canAccessAnnouncement,
  ]);

  return {
    fallback,
    loading: loading || !delayDone,
  };
};